import React, { Component,useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { Messages } from 'primereact/messages';
import { confirmPopup,ConfirmPopup } from 'primereact/confirmpopup'
import AppContext from '../../AppContext';
import { ContextMenu } from 'primereact/contextmenu';
import { ButtonMenu } from './ButtonMenu';

export class DataGrid extends Component{
	static contextType = AppContext;

	constructor(props) {
        super(props);
        //props:
        //setRecs(recs)
        //setSelectedRecs(recs)
        //loadRecords(parentId)
        //insertMultiple(parentId,recs,recType)
        //insertRecord(parentId,rec,recType)
        //deleteRecord(rec)
        //deleteRecords(rec)
        //updateRecord(parentId,rec,recType)
        //recordAdded(rec)
        //recordDeleted(rec)
        //recordUpdated(rec)
        //recType
        //dialogHeader
        //insertMenu,filterMenu,editMenu,exportMenu,importMenu
		//editButton,openButton
		//initRecord
		//initEditRecord
		//commandMenuItems
		//commandMenu
		//importAction
		//commandAction
		//selectionChanged(rec)
		//reload
		//leftContents,rightContents
		//isDataSelectable
		//t

		this.messages = React.createRef();
		this.exportMenu = React.createRef();
		this.importMenu = React.createRef();
		this.editMenu = React.createRef();
		this.gridMessage = React.createRef();
		this.dataTable = React.createRef();
		this.commandMenu = React.createRef();
		this.contextMenu = React.createRef();
		this.t=(m)=>{return m};

		if(this.props.t!=undefined)
			this.t=this.props.t;

		this.state = {
			parentId:0,
			selectedRec:{},			
			filterOn:false
        };	
		this.setMenuItems();
		this.editRecord = this.editRecord.bind(this);
		this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
		this.insertRecord = this.insertRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.deleteRecords = this.deleteRecords.bind(this);
		this.copyToClipboard = this.copyToClipboard.bind(this);
		this.pasteFromClipboard = this.pasteFromClipboard.bind(this);
		this.exportCSV = this.exportCSV.bind(this);
		this.setFilter = this.setFilter.bind(this);	
		this.openPage = this.openPage.bind(this);
		this.isDataSelectable = this.isDataSelectable.bind(this);
    }
	setMenuItems()
	{
		this.exportMenuItems = [
			{
			   label:this.t('Export_as_CSV'),
			   icon:'pi pi-file',
			   command: ()=>{this.exportCSV()}
			},
			{
			   label:this.t('Export_as_XLSX'),
			   icon:'pi pi-file-excel'
			},
			{
			   label:this.t('Export_as_PDF'),
			   icon:'pi pi-file-pdf'
			}
		 ];
		
		this.importMenuItems = [
			{
			   label:this.t('Export_as_CSV'),
			   icon:'pi pi-fw pi-plus',
			},
			{
			   label:this.t('Export_as_XLSX'),
			   icon:'pi pi-fw pi-trash'
			},
			{
			   label:this.t('Export_as_PDF'),
			   icon:'pi pi-fw pi-external-link'
			}
		 ];
		
		this.editMenuItems = [
			{
			   label:this.t('Copy_selected_rows'),
			   command: ()=>{this.copyToClipboard()}
			},
			{
			   label:this.t('Paste_rows'),
			   command: ()=>{this.pasteFromClipboard()}
			} 
		];		
		if(this.props.commandMenuItems != undefined)
		{
			for(var i=0;i<this.props.commandMenuItems.length;i++)
			{
				let act = this.props.commandMenuItems[i].action;
				this.props.commandMenuItems[i].command=()=>{this.commandAction(act)};
			}
		}
		if(this.props.contextMenuItems != undefined)
		{
			for(var i=0;i<this.props.contextMenuItems.length;i++)
			{
				let act = this.props.contextMenuItems[i].action;
				this.props.contextMenuItems[i].command=()=>{this.contextAction(act)};
			}
		}
	}
	componentDidMount() {
		this._loadRecs();
	}
	componentDidUpdate(prevProps, prevState) {
		if(prevProps.parentId == null)
			return;		

		if (this.props.parentId !== prevProps.parentId || this.props.reload) {
			this._loadRecs();
		}
	}	
	_loadRecs()
	{
		console.log('_loadRecs...'+this.props.parentId);
		if(this.props.parentId == null)
			return;		
		var ret = this.props.loadRecords(this.props.parentId);
	}
	openPage(rec)
	{
		if(this.props.openPage != undefined)
			this.props.openPage(rec);
	}
	editRecord(rec)
	{
		var sr = rec;
		if(this.props.editRecord != undefined)
			sr = this.props.editRecord(rec);
	}	
	setFilter(val)
	{
		this.setState({filterOn:val});
	}
	isDataSelectable(e)
	{
		if(this.props.isDataSelectable!=undefined)
			return this.props.isDataSelectable(e);
		return true;
	}
	copyToClipboard()
	{
		var _clip = [];
		for(var i=0; i<this.props.selectedRecs.length; i++)
		{
			let str = JSON.stringify(this.props.selectedRecs[i]);
			let _copy = JSON.parse(str);

			console.log(JSON.stringify(_copy));
			_clip.push(_copy);
		}
		this.context.clip = _clip;
		this.context.clipType = this.props.recType;
	}
	pasteFromClipboard()
	{
		if(this.context.clipType != this.props.recType)
		{
			this.gridMessage.current.show({ severity: 'error', summary: 'error', detail: this.t('Not_suitable_for_this_table_Expecting')+this.props.recType+' '+this.t("found:")+this.context.clipType });
			return;
		}
		for(var i=0; i<this.context.clip.length; i++)
			console.log('clip['+i+'] = '+JSON.stringify(this.context.clip[i]));
		var ret = this.props.insertMultiple(this.props.parentId,this.context.clip,this.props.recType);
		ret.then(r => { this._loadRecs() });
	}
	insertRecord()
	{
		console.log("insertrec called");
		var rec={};
		if(this.props.initRecord != undefined)
			rec = this.props.initRecord();
		if(this.props.insertRecord)
			this.props.insertRecord(rec);
	}
	deleteRecord(e)
	{
		if(this.pros.selectedRecs.length == 0)
			return;
			confirmPopup({
				target:e.currentTarget,
				message: this.t('Are_you_sure_you_want_to_delete_selected_items'),
				header: 'Confirmation',
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					let _cat = this.props.selectedRecs[0]; //TODO
					var ret = this.props.deleteRecord(_cat); 
					ret.then(()=>{
						let ind = this.findIndex(_cat);
						let _cats = this.props.recs;
						_cats.splice(ind,1);
						this.props.setRecs(_cats);
                        this.props.setSelectedRecs([]);
						this.props.catDeleted(_cat);
					}).catch((error)=>{
						this.gridMessage.current.show({ severity: 'error', summary: 'error', detail: error.message });
						console.log('GenericGrid:deleteRec:error='+error);
					});
				}
			});			
	}
	deleteRecords(e)
	{
		if(this.props.selectedRecs.length == 0)
			return;
		confirmPopup({
			target:e.currentTarget,
			message: this.t('Are_you_sure_you_want_to_delete_selected_items'),
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				let ids=[];
				for(var i=0; i<this.props.selectedRecs.length; i++)
					ids.push(this.props.selectedRecs[i].id);
				var ret = this.props.deleteRecords(ids); 
				ret.then(()=>{
					this._loadRecs();
				}).catch((error)=>{
					this.gridMessage.current.show({ severity: 'error', summary: 'error', detail: error.message} );
					console.log('GenericGrid:deleteRec:error='+error);
				});
			}
		});			
	}
	findIndex(rec)
	{
		for(var i=0; i<this.props.recs.length; i++)
		{
			if(this.props.recs[i].id == rec.id)
				return i;
		}
		return -1;
	}
	renderContextMenu=(rowData)=>{
		if(!this.props.contextMenuAsDropdown)
		{			
			var menu = this.props.contextMenuItems.map((item)=>{
				return <Button size="small" severity="secondary" icon={item.icon} label={item.label} onClick={()=>this.contextAction(item.actionName,rowData)}/>
			});
			return <div className='flex gap-1'>{menu}</div>;
		}
		var menuItems = this.props.contextMenuItems.map((item)=>{
			return {...item,command:()=>{this.contextAction(item.actionName,rowData)}};
		})	
		return (
			<ButtonMenu items={menuItems} icon="pi pi-th-large" label={''}></ButtonMenu>
		)
	}
	actionBodyTemplate(rowData) {
		const btnCls = 'p-button-rounded p-button-sm p-button-text p-button-secondary mr-2 ';
		const editCls = btnCls + (this.props.editButton?'':'hidden');
		const openCls = btnCls + (this.props.openButton?'':'hidden');
		if(this.props.contextMenuItems)
			return this.renderContextMenu(rowData);
        return (
			<div className='flex'>
            <React.Fragment>
                <Button icon="pi pi-pencil" className={editCls} onClick={() => this.editRecord(rowData)} />
                <Button icon="pi pi-link" className={openCls} onClick={() => this.openPage(rowData)} />
				{/*<Button icon="pi pi-trash" className="p-button-rounded p-button-sm p-button-text p-button-danger" onClick={() => this.confirmDeleteProduct(rowData)} />*/}
            </React.Fragment>
			</div>
        );
	}	
	showError = (err) => {
		this.messages.current.show({ severity: 'error', summary: '', detail: err });
	}	
	rowSelected=(e)=>{
		console.log("onRowSelect:"+e.type);
		if(e.type == 'row')
		{
			console.log('e.timestamp:'+e.originalEvent.timeStamp);
			this.setState({consumeRowSelect:e.originalEvent.timeStamp});
			if(this.props.setSelectedRecs != undefined)
				this.props.setSelectedRecs([e.data]);
			this.setState({selectedRec:e.data});
			if(this.props.selectionChanged != undefined)
				this.props.selectionChanged(e.data);
		}
	}
	selectionChanged=(e)=>{
		console.log('selectionChanged:'+e.originalEvent.timeStamp);
		if(e.originalEvent.target.tagName!=undefined && e.originalEvent.target.tagName.startsWith('TD'))
			return;
		if(this.props.setSelectedRecs != undefined)
			this.props.setSelectedRecs(e.value);		
	}
	exportCSV()
	{
		this.dataTable.current.exportCSV(false);
	}
	reset()
	{
		this.dataTable.current.reset();
	}
	resetColumnOrder()
	{
		this.dataTable.current.resetColumnOrder();
	}
	commandAction=(action)=>{
		console.log('command action:'+action);
		let ids=[];
		for(var i=0; i<this.props.selectedRecs.length; i++)
			ids.push(this.props.selectedRecs[i].id);

		this.props.commandAction(action,ids);
	}
	contextAction=(action,rec)=>{
		console.log('context action:'+action);

		this.props.contextAction(action,rec);
	}
	render()
	{		
		const btnCls = 'p-button-sm mr-2 ';
		const exportCls = btnCls + (this.props.exportMenu?'p-button-secondary':'hidden');
		const importCls = btnCls + (this.props.importMenu?'p-button-secondary':'hidden');
		const deleteCls = btnCls + (this.props.deleteMenu?'p-button-danger':'hidden');
		const insertCls = btnCls + (this.props.insertMenu?'p-button-secondary':'hidden');
		const commandCls = btnCls + (this.props.commandMenu?'p-button-secondary':'hidden');

		const filterCls = (this.props.filterMenu?'mr-2':'hidden');
		const editCls = btnCls + (this.props.editMenu?'p-button-secondary':'hidden');

		console.log('DataGrid:render');
		var leftContents = (
			<React.Fragment>
				<Button className={insertCls} label={this.t("New")} icon="pi pi-plus" onClick={this.insertRecord} />
				<Button className={commandCls} label={this.t("Command")} icon="pi pi-cog" disabled={this.props.selectedRecs.length == 0} onClick={(event) => this.commandMenu.current.toggle(event)}/>	
			</React.Fragment>
		);

		var paginator="paginator";
		if(this.props.paginator==false)
			paginator="";
		var rightContents = (
			<React.Fragment>
				<Menu model={this.exportMenuItems} popup ref={this.exportMenu} />
				<Menu model={this.importMenuItems} popup ref={this.importMenu} />
				<Menu model={this.editMenuItems} popup ref={this.editMenu} />
				<Menu model={this.props.commandMenuItems} popup ref={this.commandMenu}/>

				<Button className={editCls} label={this.t("Copy-paste")} icon="pi pi-copy" onClick={(event) => this.editMenu.current.toggle(event)}/>	
				<Button className={importCls} label={this.t("Import")} icon="pi pi-download" onClick={(event) => this.props.importAction(event)}/>	
				<Button className={exportCls} label={this.t("Export")} icon="pi pi-upload" onClick={(event) => this.exportMenu.current.toggle(event)}/>	
				<ToggleButton className={filterCls} onLabel={this.t("Filter")} offLabel="Filter" checked={this.state.filterOn} icon="pi pi-trash" onChange={(e) => this.setFilter(e.value)} />
				<Button className={deleteCls} label={this.t("Delete")} icon="pi pi-trash" onClick={this.deleteRecords} disabled={this.props.selectedRecs.length == 0} />
				{this.toolbarExtra}
			</React.Fragment>
		);				
		if(this.props.leftContents)
			leftContents = this.props.leftContents;
		if(this.props.rightContents)
			rightContents = this.props.rightContents;
		var contextMenu = <></>;
		if(this.props.contextMenuItems != undefined)
			contextMenu = <ContextMenu model={this.props.contextMenuItems} ref={el => this.contextMenu = el}/>;
		return (
			<div className="">
			<Messages ref={this.gridMessage}></Messages>
			{contextMenu}
			<Toolbar left={leftContents} right={rightContents} />
			<DataTable ref={this.dataTable} value={this.props.recs} className="p-datatable-striped p-datatable-sm" size="small" selectionMode="single"  {...paginator} rows={10}
					selection={this.props.selectedRecs} onSelectionChange={e => this.selectionChanged(e)} dataKey="id" onRowSelect={(e)=>this.rowSelected(e)}
					contextMenuSelection={this.state.selectedRec} onContextMenuSelectionChange={e => this.setState({ selectedRec: e.value })}
					showGridlines isDataSelectable={e => this.isDataSelectable(e)}>
                <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
				{React.Children.map(this.props.children, child => {
            		return React.cloneElement(child, {
              		filter: this.state.filterOn })   
         		})}                
				<Column body={this.actionBodyTemplate} style={{width:'10%'}}></Column>
    		</DataTable>
			<ConfirmPopup />
			</div>
		)
	}
	
}
export default DataGrid;
